import { defineStore } from 'pinia'
import {computed, ref} from 'vue'

export const useCableConfiguratorStore = defineStore('cableConfigurator', () =>
{
    let bendOption = ref({ label: '', value: ''})
    let countNoOption = ref({ label: '', value: ''})
    let cableLength = ref(0)
    let base = ref('')
    let contactNo = ref('')
    // let filler = ref('-P')

    let showOverlay = ref(false)
    let availableCableConfiHint = ref(false)
    let scrollToCableConfi = ref(false)

    const cableConfigurationId = computed(() =>
    {
        return contactNo
    })

    const configuredCableConfigurationIdWithoutLength = computed(() =>
    {
        return base.value + bendOption.value.value + countNoOption.value.value
    })

    const configuredCableConfigurationId = computed(() =>
    {
        return configuredCableConfigurationIdWithoutLength.value + cableLength.value.toString().padStart(6, '0')
    })



    function clearConfiguration ()
    {
        // bendOption.value = { label: '', value: ''}
        // countNoOption.value = { label: '', value: ''}
        // cableLength = 0
        // base = ''
        // contactNo = ''
    }

    function setCableConfigurationValues (id, baseNo)
    {
        base.value = baseNo
        contactNo.value = id

    }

    function setPredefinedValues (id, typeKey, cableConfig)
    {
        const predefinedBend = id.slice(9, 11)
        const predefinedCountNo = id.slice(11, 13)
        if (cableConfig.bendOptions.filter(el => el.value === predefinedBend).length)
        {
            bendOption.value = cableConfig.bendOptions.filter(el => el.value === predefinedBend)[0]
        } else {
            bendOption.value = { label: '', value: ''}
        }
        if (cableConfig.countNoOptions.filter(el => el.value === predefinedCountNo).length)
        {
            countNoOption.value = cableConfig.countNoOptions.filter(el => el.value === predefinedCountNo)[0]
        } else {
            countNoOption.value = { label: '', value: ''}
        }
    }

    return {
        bendOption,
        countNoOption,
        cableLength,
        cableConfigurationId,
        clearConfiguration,
        configuredCableConfigurationId,
        configuredCableConfigurationIdWithoutLength,
        setCableConfigurationValues,
        setPredefinedValues,
        base,
        contactNo,
        showOverlay,
        scrollToCableConfi,
        availableCableConfiHint
    }
})